import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { 
  Heart, 
  HandHeart, 
  MessageCircle, 
  UtensilsCrossed, 
  Palette, 
  Theater, 
  Lightbulb, 
  Leaf 
} from 'lucide-react';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const CATEGORIES = {
  bienestar: { 
    icon: Heart, 
    color: "#5dc8e3",
    bgColor: "rgba(93, 200, 227, 0.15)",
    textColor: "#4ab5d0"
  },
  causas: { 
    icon: HandHeart, 
    color: "#de9bb9",
    bgColor: "rgba(222, 155, 185, 0.15)",
    textColor: "#c987a5"
  },
  charlas: { 
    icon: MessageCircle, 
    color: "#f7747a",
    bgColor: "rgba(247, 116, 122, 0.15)",
    textColor: "#e55a60"
  },
  comida: { 
    icon: UtensilsCrossed, 
    color: "#9984dd",
    bgColor: "rgba(153, 132, 221, 0.15)",
    textColor: "#8571ca"
  },
  creativo: { 
    icon: Palette, 
    color: "#fed543",
    bgColor: "rgba(254, 213, 67, 0.15)",
    textColor: "#d4b236"
  },
  cultura: { 
    icon: Theater, 
    color: "#fdbd43",
    bgColor: "rgba(253, 189, 67, 0.15)",
    textColor: "#e5a830"
  },
  innovacion: { 
    icon: Lightbulb, 
    color: "#72e3d7",
    bgColor: "rgba(114, 227, 215, 0.15)",
    textColor: "#5cc9be"
  },
  naturaleza: { 
    icon: Leaf, 
    color: "#99cc00",
    bgColor: "rgba(153, 204, 0, 0.15)",
    textColor: "#7fa800"
  }
};

export const getCategoryInfo = (category) => {
  return CATEGORIES[category] || CATEGORIES.bienestar;
};

export const formatDate = (dateStr, locale = 'es-MX') => {
  if (!dateStr) return '';
  const date = new Date(dateStr + 'T12:00:00');
  return date.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const formatDateShort = (dateStr, locale = 'es-MX') => {
  if (!dateStr) return '';
  const date = new Date(dateStr + 'T12:00:00');
  return date.toLocaleDateString(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
};

export const formatDateHeroShort = (dateStr, locale = 'es-MX') => {
  if (!dateStr) return '';
  const date = new Date(dateStr + 'T12:00:00');
  const weekday = date.toLocaleDateString(locale, { weekday: 'short' });
  const dayMonth = date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
  return `${weekday} ${dayMonth}`;
};

export const formatTime = (timeStr) => {
  return timeStr;
};

export const formatPrice = (price, locale = 'es-MX') => {
  if (price === 0) return null;
  return `$${price.toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} MXN`;
};

export const isActivityPast = (dates) => {
  if (!dates || dates.length === 0) return true;
  const now = new Date();
  const lastDate = new Date(dates[dates.length - 1].date);
  return lastDate < now;
};

export const getNextDate = (dates) => {
  if (!dates || dates.length === 0) return null;
  const now = new Date();
  for (const dateInfo of dates) {
    const date = new Date(dateInfo.date);
    if (date >= now) return dateInfo;
  }
  return dates[0];
};
